import * as actionTypes from 'actions';
import { useSelector } from 'react-redux';
import type { ReduxAction, RootState, SessionState } from './types';

const initialState: SessionState = {
  loggedIn: false,
  loading: true,
  user: {
    id: 0,
    firstName: null,
    lastName: null,
    email: null,
    loginID: null,
    sessionID: null,
    privileges: null,
    isAdmin: false
  }
};

const sessionReducer = (state = initialState, action: ReduxAction<Partial<SessionState['user']>> = {}) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      const { payload } = action;
      return {
        ...state,
        loggedIn: true,
        loading: false,
        user: {
          ...payload
        }
      };
    }

    case actionTypes.SESSION_LOGOUT: {
      return {
        ...state,
        loggedIn: false,
        loading: false,
        user: {
          role: 'GUEST'
        }
      };
    }

    default: {
      return state;
    }
  }
};

export const useSessionSelector = () => useSelector<RootState, SessionState>((state) => state.session);

export default sessionReducer;
